import React from 'react';
import { useDispatch } from 'react-redux';
import { loadUserFromSalesforce } from 'actions/user';
import queryString from 'query-string';
import jsforce from 'jsforce';

export const Salesforce = ({ history, location }) => {
    const dispatch = useDispatch();

    const salesforce = (accessToken, session, email, url, callback) =>
        dispatch(loadUserFromSalesforce(accessToken, session, email, url, callback));

    React.useEffect(() => {
        const values = queryString.parse(location.search);
        const conn = new jsforce.Connection({
            serverUrl: values.url,
            sessionId: values.session,
        });

        salesforce(conn.accessToken, values.session, values.email, values.url, () => history.push('/'));
    }, []);

    return (
        <div className="flex flex-center flex-column">
            <h3>Logging into Accelerate Insights from Salesforce...</h3>
            <div>
                <i className="fa fa-spin fa-cog text-lg mr10" />
                Please Wait
            </div>
        </div>
    );
};

export default Salesforce;
